import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * 月額会員バッジのラベル（確定）。
 */
export const MONTHLY_MEMBER_BADGE_LABEL = "月額会員";

/**
 * 現在のユーザーが相続後リユース候補の有効な月額プラン保持者かを判定する。
 *
 * BE（/user/current）の is_inheritance_reuse_monthly_member を正本とする
 * （apiClient の case 変換で isInheritanceReuseMonthlyMember）。
 */
export const useIsMonthlyMember = (): boolean => {
  const user = useCurrentUser();
  return user?.isInheritanceReuseMonthlyMember === true;
};
